<p-messages [value]="postActionErrorMessage"></p-messages>
<p-card header="Group Details">    
    <form [formGroup]="addUserGroupForm" (ngSubmit)="onSubmit()">
        <div class="ui-grid ui-grid-responsive formcontainer">           
            <div class="formgroup">
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                    <label for="RelationshipGroupName">Group Name</label>
                    </div>
                </div>
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                    <input type="text" pInputText formControlName="userGroupName" [style]="{'width':'500px'}" (blur)="onUserGroupNameChange()" >
                    </div>
                </div>
            </div>
            <div class="formgroup">
                <div *ngIf="userGroupNameControl.invalid 
                    && (userGroupNameControl.dirty || userGroupNameControl.touched) 
                    && userGroupNameControl.errors.required" class="custom-required">
                    Group Name is required.
                </div>
                <div *ngIf="userGroupExists" class="custom-required">User Group Name already exists. Please enter a different name.</div>
            </div>

            <div class="formgroup">
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                    <label for="Relationship">Partnership</label>    
                    </div>
                </div>                    
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                    <p-dropdown 
                        [options]="relationship" 
                        optionLabel="Company.Name" 
                        formControlName="RelationshipId" 
                        placeholder="Select One" 
                        [style]="{'width':'250px'}" 
                        (onChange)="relationshipChange()">
                    </p-dropdown>
                    <div *ngIf="relationshipControl.invalid 
                        && (relationshipControl.dirty || relationshipControl.touched) 
                        && relationshipControl.errors.required" class="custom-required">
                        Please select Partnership.
                    </div>
                    </div>
                </div> 
            </div>

            <div class="formgroup">
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                    <label for="Relationship">Privileges</label>    
                    </div>
                </div>                    
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                        <div class="ui-grid-row">
                            <app-privilege-dropdown
                                [privilegeGroup]="privilegesWithRelationship"
                                formControlName="PrivilegeIds"                               
                                [maxSelectedLabels]="1"
                                [group]=true
                                defaultLabel="Select Privilege" 
                                filterPlaceHolder=""
                                (onChange)="selectPrivileges($event)">
                            </app-privilege-dropdown>
                            <i class="pi pi-info-circle" style="font-size:24px" pTooltip="Privileges control what each user is able to see and do in the EQ Connect Portal. This Master set creates an Admin privilege group which the Primary Contact will be part of.  If given the Add/Edit Partner Users privilege, the Admins can assign all or a subset of the Master set to each additional user."></i>
                            <span [ngClass]="{'check-circle-gray': privilegeDataControl.invalid,
                                                'check-circle-green': !privilegeDataControl.invalid}">
                                <i class="pi pi-check-circle" 
                                    (mouseover)="displaySelectedItems(dtPrivileges, $event)" 
                                    (mouseout)="dtPrivileges.hide($event)"></i>
                            </span>
                        </div>
                        <div *ngIf="privilegeDataControl.invalid 
                            && privilegeDataControl.touched
                            && privilegeDataControl.errors.required" class="custom-required">
                            Please select a Privilege.
                        </div>
                    </div>
                </div>
            </div>
            <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="cancelAddUserGroup()" [disabled]="processing"></button>                    
            <button pButton label="{{processing ? 'Processing' : 'Save'}}" [disabled]="processing || userGroupExists || addUserGroupForm.invalid" type="submit"></button>
        </div>            
    </form>
    <p-overlayPanel #dtPrivileges [dismissable]="true">
        <ul>
           <li *ngFor="let privilegeGroupItem of privilegesSelectedToolTip">
                <b>{{privilegeGroupItem.Key}}</b>
                <ul>
                  <li *ngFor="let privilege of privilegeGroupItem.Privilege">{{privilege.PrivilegeName}}</li>
                </ul>
            </li>
        </ul>
      </p-overlayPanel>
</p-card>
